import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {Button, Form, Modal, Table, Container, Row, Tooltip, OverlayTrigger,} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { checkAuthenticate } from "../app/providers/authSlice";
import MatieresService from "../matieres/MatieresService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClassesService from "../classe/ClassesService";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import $ from "jquery";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import CivilitesService from "../civilites/CivilitesService";
import AdminService from "../auth/AdminService";
import Filarial from "../include/filarial";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { borderColor } from "@mui/system";
import SexesService from "../sexes/SexesService";
import PaysService from "../pays/PaysService";
import TypescontratsService from "../typescontrats/TypescontratsService";
import EnseignantsService from "./EnseignantsService";
import { Dropdown } from "primereact/dropdown";

export default function EnseignantCreate() {
  const activeLink = "ENSEIGNANTS";

  const [nom, setNom] = useState("");
  const [prenoms, setPrenoms] = useState("");
  const [ifuEnseignant, setIfuEnseignant] = useState("");
  const [cnssEnseignant, setCnssEnseignant] = useState("");
  const [debutcontratEnseignant, setDebutcontrat] = useState("");
  const [fincontratEnseignant, setFincontrat] = useState("");
  const [diplomeEnseignant, setDiplomeEnseignant] = useState("");
  const [salaireEnseignant, setSalaireEnseignant] = useState("");
  const [sexeId, setSexeId] = useState("");
  const [sexes, setSexes] = useState([]);
  const [typecontratId, setTypescontratId] = useState("");
  const [typescontrats, setTypescontrats] = useState([]);
  const [telephone, setTelephone] = useState("");
  const [matiereId, setMatiereId] = useState("");
  const [matieres, setMatieres] = useState([]);
  const [classeId, setClasseId] = useState("");
  const [classes, setClasses] = useState([]);
  const [classeoptionId, setClasseoptionId] = useState("");
  const [classesoptions, setClassesoptions] = useState([]);
  const [email, setEmail] = useState("");
  const [ddn, setDdn] = useState("");
  const [lieuNaissance, setLieuNaissance] = useState("");
  const [civiliteId, setCiviliteId] = useState("");
  const [civilites, setCivilites] = useState([]);
  const [civiliteSelected, setCiviliteSelected] = useState("");
  const [pays, setPays] = useState([]);
  const [paysId, setpaysId] = useState("");
  //const [nationalites, setNationalites] = useState([]);
  //const [nationaliteId, setNationaliteId] = useState("");
  const [photoEnseignant, setPhotoEnseignant] = useState("");
  const [selectedOptionPays, setSelectedOptionPays] = useState(null);
  const [selectedOptionMatiere, setSelectedOptionMatiere] = useState(null);
  const [selectedOptionCivilite, setSelectedOptionCivilite] = useState(null);
  const [selectedOptionSexe, setSelectedOptionSexe] = useState(null);
  const [selectedOptionClasse, setSelectedOptionClasse] = useState(null);
  const [selectedOptionNationalite, setSelectedOptionNationalite] = useState(null);
  const [selectedOptionTypecontrats, setSelectedOptionTypecontrats] =
    useState(null);

  //const [index, setIndex] = useState(0);

  ///Variable pour enregistrer une matière
  const [libelleMatiere, setLibelleMatiere] = useState("");
  const [descriptionMatiere, setDescriptionMatiere] = useState("");
  const [coefficientMatiere, setCoefficientMatiere] = useState("");

  //ajout de ligne
  const [groupCount, setGroupCount] = useState(1);

  // États pour stocker les sélections et options de classe
  const [selectedClasseOptions, setSelectedClasseOptions] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([""]);
  const [availableOptions, setAvailableOptions] = useState([]);

  const [date, setDate] = useState(null);

  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();

  const animatedComponents = makeAnimated();
  const [validationError, setValidationError] = useState({});

  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);

  ///Get liste des classes
  const fetchClasses = async () => {
    await ClassesService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setClasses(res.data.data.classes);
      })
      .catch((error) => {
        console.log(error);
      });
  };


  // formater les données de la classe

  const dataclasses = classes.map((item) => {
    return {
      label: item.libelleClasse,
      value: item.id,
    };
  });


  //Recupérer les classes qui seront sélectionnée
  // Gérer la sélection d'une classe
  const handleClasseSelection = async (event, index) => {
    const { value } = event.target;
    //setSelectedClasses([...selectedClasses.slice(0, index), value, ...selectedClasses.slice(index + 1)]);
    setSelectedClasses([...selectedClasses.slice(0, index), value]);
    setClasseId(value);
    // console.log("Selected Classe:", value); // Ajout de ce log
    // Réinitialise les options de classe sélectionnées

    setSelectedClasseOptions([
      ...selectedClasseOptions.slice(0, index),
      [],
      ...selectedClasseOptions.slice(index + 1),
      console.log(...selectedClasseOptions.slice(index + 1)),
    ]);

    try {
      // Appel à l'API pour récupérer les options de classe
      const response = await ClassesoptionsService.getOptionByClasse(
        value,
        token
      );
      const data = await response.data.data;
      const options = data.map((item) => ({
        value: item.id,
        label: item.libelleClasseOption,
      }));

      // Mettre à jour les options disponibles pour la ligne spécifique
      //Cette ligne crée un nouveau tableau auquel on ajoute la nouvelle options selon l'index
      setAvailableOptions([...availableOptions.slice(0, index), options]);

      //setAvailableOptions([...availableOptions.slice(0, index), options, ...availableOptions.slice(index + 1)]);
    } catch (error) {
      console.error(error);
    }
  };

  //Recupérer les classes options qui seront sélectionnée
  // Gérer la sélection des options de classe
  const handleClasseOptionsSelection = (selectedOptions, index) => {
    setSelectedClasseOptions([
      ...selectedClasseOptions.slice(0, index),
      selectedOptions,
      ...selectedClasseOptions.slice(index + 1),
    ]);
    /* console.log("Nouveau tableau sélectionné:", [
      ...selectedClasseOptions.slice(0, index),
      selectedOptions,
      ...selectedClasseOptions.slice(index + 1),
    ]);*/
  };

  //Ajout dynamique de ligne
  const addRow = () => {
    setGroupCount(groupCount + 1);
    // Ajoute un tableau vide pour les options de classe du nouveau groupe
    setSelectedClasseOptions([...selectedClasseOptions, []]);
    // Ajoute une chaîne vide pour la classe du nouveau groupe
    setSelectedClasses([...selectedClasses, ""]);
  };

  //Suppression des lignes ajoutés
  const removeRow = (index) => {
    if (groupCount > 1) {
      setGroupCount(groupCount - 1);
      setSelectedClasseOptions([
        ...selectedClasseOptions.slice(0, index),
        ...selectedClasseOptions.slice(index + 1),
      ]);
      setSelectedClasses([
        ...selectedClasses.slice(0, index),
        ...selectedClasses.slice(index + 1),
      ]);
    } else {
      Swal.fire({
        icon: "error",
        text: "Attention, vous ne pouvez pas supprimer cette donnée.",
        showConfirmButton: true,
        timer: 3000,
      });
    }
  };

  //get liste civilites
  const fetchCivilites = async () => {
    await CivilitesService.index(token)
      .then((response) => {
        setCivilites(response.data.data.civilites);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const optionscivilites = civilites.map((item) => ({
    value: item.id,
    label: item.libelleCivilite,
  }));

  //get liste pays
  const fetchPays = async () => {
    await PaysService.index_pays(token)
      .then((response) => {
        setPays(response.data.data);
        //console.log(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // formater les données du pays

  const datapays = pays.map((item) => {
    return {
      label: item.nompaysPays,
      value: item.id,
    };
  });

  /*const handlePaysChange = (selectedOption) => {
    setSelectedOptionPays(selectedOption);
  };*/


 

  //Afficher le modal de détail user
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const storeMatiere = async (event) => {
    event.preventDefault();

    let form = {
      libelleMatiere,
      descriptionMatiere,
      coefficientMatiere,
    };

    await MatieresService.store(form, token)
      .then((response) => {
        //console.log(response.data.data)
        if (response.data.status === 200) {
          Swal.fire({
            icon: "success",
            text: response.data.message,
            timer: 3000,
          });
          //Mettre à jour la liste des matières
          fetchMatieres();
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          text: error.message,
        });
        //affichage des erreurs sur le formulaire
        //setValidationError(error.message)
      });

    //Fermer le modal
    return setShow(false);
  };

  const handleSubmitData = async (e) => {
    e.preventDefault();
    // Récupérez les valeurs des classes options
    const classeoptionValue = selectedClasseOptions
      .map((options) => {
        if (options) {
          return options.map((option) => option.value);
        } else {
          return [];
        }
      })
      .flat();

    const formData = new FormData();
    formData.append("nom", nom);
    formData.append("prenoms", prenoms);
    formData.append("ifuEnseignant", ifuEnseignant);
    formData.append("cnssEnseignant", cnssEnseignant);
    formData.append("matiereId", selectedOptionMatiere);
    formData.append("telephone", telephone);
    formData.append("classeoptionId", classeoptionValue);
    formData.append("classeId", classeId);
    formData.append("civiliteId", civiliteId);
    formData.append("email", email);
    formData.append("paysId", selectedOptionPays);
    formData.append("lieuNaissance", lieuNaissance);
    formData.append("debutcontratEnseignant", debutcontratEnseignant);
    formData.append("fincontratEnseignant", fincontratEnseignant);
    formData.append("diplomeEnseignant", diplomeEnseignant);
    formData.append("salaireEnseignant", salaireEnseignant);
    formData.append("typecontratId", typecontratId);
    formData.append("sexeId", sexeId);
    //formData.append("nationaliteId", selectedOptionNationalite);
    formData.append("photoEnseignant", photoEnseignant);
    formData.append("ddn", ddn);

    for (var pair of formData.entries()) {
      console.log(pair[0]+ ', ' + pair[1]); 
  }

    try {
      const response = await EnseignantsService.store(formData, token);

      if (response.data.status === 200) {
        //redirection sur index
        navigate(myroutes.enseignants_index);
        Swal.fire({
          icon: "success",
          text: response.data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response.data.message,
          showConfirmButton: true,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: error.message,
      });
    }
  };

  //get liste matières
  const fetchMatieres = async () => {
    await MatieresService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setMatieres(res.data.data.matieres);
      })
      .catch((error) => {
        console.log(error);
      });
  };

   // formater les données des matières
   const datamatieres = matieres.map((item) => {
    return {
      label: item.libelleMatiere,
      value: item.id,
    };
  });


  //get liste sexes
  const fetchSexes = async () => {
    await SexesService.index(token)
      .then((res) => {
        setSexes(res.data.data.sexes);
        // console.log("sexes", res.data.data.sexes)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste types contrats
  const fetchTypescontrats = async () => {
    await TypescontratsService.index(token)
      .then((res) => {
        setTypescontrats(res.data.data.typescontrats);
        //console.log("types contrats", res.data.data.typescontrats)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }

    fetchMatieres();
    fetchClasses();
    fetchCivilites();
    fetchPays();
    fetchSexes();
    fetchTypescontrats();
  }, [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />

        <div className="row mb-4 mt-3">
          {/* Bootstrap Validation */}
          <div className="col-md">
            <div className="card shadow-lg">
              <div className="col-md-12 text-center">
                <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">
                  Enregistrement d'un enseignant
                </h5>
              </div>
              <div className="card-body">
                <Row>
                  {Object.keys(validationError).length > 0 && (
                    <div className="row">
                      <div className="col-12">
                        <div className="alert alert-danger">
                          <ul className="mb-0">{<li>{validationError}</li>}</ul>
                        </div>
                      </div>
                    </div>
                  )}
                </Row>
                <Form
                  encType="multipart/form-data"
                  method="POST"
                  onSubmit={handleSubmitData}
                >
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div
                          className="col-md-6"
                          style={{
                            borderRight: "1px solid rgb(225, 224, 224)",
                          }}
                        >
                          <div className="col-md-12 ">
                            <div className="row">
                              <div className="col-md-6 mb-3">
                                <Form.Label
                                  className="form-label fw-bold"
                                  htmlFor="nom"
                                >
                                  Nom <i className="text-danger">*</i>
                                </Form.Label>
                                <Form.Control
                                  className=""
                                  onChange={(e) => setNom(e.target.value)}
                                  value={nom}
                                  placeholder="Renseignez le nom"
                                  name="nom"
                                  aria-label="nom"
                                  maxLength={100}
                                  minLength={3}
                                  type="text"
                                  required
                                />
                              </div>

                              <div className="col-md-6 mb-3">
                                <Form.Label
                                  className="form-label fw-bold"
                                  htmlFor="prenoms"
                                >
                                  Prénom (s) <i className="text-danger">*</i>
                                </Form.Label>
                                <Form.Control
                                  className=""
                                  onChange={(e) => setPrenoms(e.target.value)}
                                  value={prenoms}
                                  placeholder="Renseignez le(s) prénom (s)"
                                  name="prenoms"
                                  aria-label="prenoms"
                                  maxLength={100}
                                  minLength={3}
                                  type="text"
                                  required
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="email"
                            >
                              Email <i className="text-danger">*</i>
                            </Form.Label>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-email">
                                  Le mail doit être unique
                                </Tooltip>
                              }
                            >
                              <Form.Control
                                className=""
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                                placeholder="Renseignez l'email"
                                name="email"
                                aria-label="email"
                                maxLength={100}
                                minLength={3}
                                type="text"
                                required
                              />
                            </OverlayTrigger>
                          </div>

                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="civiliteId"
                              >
                                Civilité <i className="text-danger">*</i>
                              </Form.Label>
                              <Form.Select
                                className=""
                                id="civiliteId"
                                value={civiliteId}
                                required
                                onChange={(e) => {
                                  setCiviliteId(e.target.value);
                                }}
                              >
                                <option value="" selected>
                                  -- Sélectionnez --
                                </option>
                                {civilites.length > 0 &&
                                  civilites.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.libelleCivilite}
                                    </option>
                                  ))}
                              </Form.Select>
                            </div>

                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="sexeId"
                              >
                                Sexe <i className="text-danger">*</i>
                              </Form.Label>
                              <Form.Select
                                className=""
                                id="sexeId"
                                value={sexeId}
                                required
                                onChange={(e) => {
                                  setSexeId(e.target.value);
                                }}
                              >
                                <option value="" selected>
                                  -- Sélectionnez --
                                </option>
                                {sexes.length > 0 &&
                                  sexes.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.libelleSexe}
                                    </option>
                                  ))}
                              </Form.Select>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="telephone"
                              >
                                Telephone <i className="text-danger">*</i>
                              </Form.Label>
                              <PhoneInput
                                defaultCountry="BJ"
                                international
                                value={telephone}
                                onChange={(value) => setTelephone(value)}
                                id="telephone"
                                placeholder="Numéro de téléphone"
                                required={true}
                                className="custom-phone-inputx"
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="selectedOptionPays"
                              >
                                Pays de residence{" "}
                                <i className="text-danger">*</i>
                              </Form.Label>
                              <Dropdown
                                value={selectedOptionPays}
                                onChange={(e) => setSelectedOptionPays(e.value)}
                                options={datapays}
                                optionLabel="label"
                                placeholder=" Sélectionner un pays "
                                filter
                                className="w-full md:w-25rem my-custom-class" 
                                style={{ width: '100%', height: '40px' }} 
                              />

                            </div>
                           
                          </div>

                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="bs-validation-ddn"
                              >
                                Date de naissance
                              </Form.Label>
                              <Form.Control
                                className="form-control"
                                id="ddn"
                                value={ddn}
                                type="date"
                                placeholder=""
                                name="ddn"
                                onChange={(e) => setDdn(e.target.value)}
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="lieuNaissance"
                              >
                                Lieu de naissance{" "}
                                <i className="text-danger">*</i>
                              </Form.Label>
                              <Form.Control
                                id="lieuNaissance"
                                className="form-control"
                                value={lieuNaissance}
                                type="text"
                                placeholder=""
                                onChange={(e) =>
                                  setLieuNaissance(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6" style={{}}>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="ifuEnseignant"
                              >
                                IFU <i className="text-danger">*</i>
                              </Form.Label>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-ifu">
                                    Renseignez votre numéro ifu
                                  </Tooltip>
                                }
                              >
                                <Form.Control
                                  className="form-control"
                                  id="ifuEnseignant"
                                  type="number"
                                  value={ifuEnseignant}
                                  onChange={(e) =>
                                    setIfuEnseignant(e.target.value)
                                  }
                                  placeholder=""
                                  required={true}
                                  maxLength={20}
                                  minLength={8}
                                />
                              </OverlayTrigger>
                            </div>

                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="cnssEnseignant"
                              >
                                CNSS <i className="text-danger">*</i>
                              </Form.Label>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-cnss">
                                    Renseignez votre numéro cnss
                                  </Tooltip>
                                }
                              >
                                <Form.Control
                                  className="form-control"
                                  id="cnssEnseignant"
                                  type="text"
                                  value={cnssEnseignant}
                                  onChange={(e) =>
                                    setCnssEnseignant(e.target.value)
                                  }
                                  placeholder=""
                                  required={true}
                                  maxLength={100}
                                  minLength={3}
                                />
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="diplomeEnseignant"
                              >
                                Diplôme <i className="text-danger">*</i>
                              </Form.Label>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-diplomeEnseignant">
                                    Renseignez votre niveau de diplome actuel
                                  </Tooltip>
                                }
                              >
                                <Form.Control
                                  className="form-control"
                                  id="diplomeEnseignant"
                                  type="text"
                                  value={diplomeEnseignant}
                                  onChange={(e) =>
                                    setDiplomeEnseignant(e.target.value)
                                  }
                                  placeholder=""
                                  required={true}
                                  maxLength={100}
                                  minLength={3}
                                />
                              </OverlayTrigger>
                            </div>
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="typecontratId"
                              >
                                Type de contrat <i className="text-danger">*</i>
                              </Form.Label>

                              <Form.Select
                                className=""
                                id="typecontratId"
                                value={typecontratId}
                                required
                                onChange={(e) => {
                                  setTypescontratId(e.target.value);
                                }}
                              >
                                <option value="" selected>
                                  -- Sélectionnez--
                                </option>
                                {typescontrats.length > 0 &&
                                  typescontrats.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.libelleTypecontrat}
                                    </option>
                                  ))}
                              </Form.Select>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="debutcontratEnseignant"
                              >
                                Date Début Contrat{" "}
                                <i className="text-danger">*</i>
                              </Form.Label>
                              <Form.Control
                                className="form-control"
                                id="debutcontratEnseignant"
                                value={debutcontratEnseignant}
                                type="date"
                                placeholder=""
                                onChange={(e) =>
                                  setDebutcontrat(e.target.value)
                                }
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="bs-validation-fincontratEnseignant"
                              >
                                Date Fin Contrat
                              </Form.Label>
                              <Form.Control
                                className="form-control"
                                id="fincontratEnseignant"
                                value={fincontratEnseignant}
                                type="date"
                                placeholder=""
                                name="fincontratEnseignant"
                                onChange={(e) => setFincontrat(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label"
                              htmlFor="salaireEnseignant"
                            >
                              Revenu mensuel <i className="text-danger">*</i>
                            </Form.Label>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-salaireEnseignant">
                                  Renseignez votre revenu mensuel
                                </Tooltip>
                              }
                            >
                              <Form.Control
                                className="form-control"
                                id="salaireEnseignant"
                                type="number"
                                value={salaireEnseignant}
                                onChange={(e) =>
                                  setSalaireEnseignant(e.target.value)
                                }
                                placeholder=""
                                required={true}
                                maxLength={20}
                                minLength={8}
                              />
                            </OverlayTrigger>
                          </div>
                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="photoEnseignant"
                            >
                              Ajouter une photo (taille maximum : 1 Mo){" "}
                              <i className="text-danger"></i> &nbsp; (JPEG - PNG
                              - JPG)
                            </Form.Label>
                            <Form.Control
                              className=""
                              onChange={(e) =>
                                setPhotoEnseignant(e.target.files[0])
                              }
                              name="photoEnseignant"
                              aria-label="photoEnseignant"
                             
                              type="file"
                              id="photoEnseignant"
                              accept="image/jpeg, image/jpg, image/png, image/PNG, image/JPG, image/JPEG"
                            />
                          </div>
                          <div className="col-md-12 mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="matiereId"
                            >
                              Matières <i className="text-danger">*</i>&nbsp;
                              &nbsp;
                              <Button
                                className="btn btn-sm rounded-5"
                                variant="primary"
                                onClick={handleShow}
                                title="Ajouter"
                              >
                                <FontAwesomeIcon icon="fa-solid fa-circle-plus" />
                              </Button>
                            </Form.Label>
                            <Dropdown
                                value={selectedOptionMatiere}
                                onChange={(e) => setSelectedOptionMatiere(e.value)}
                                options={datamatieres}
                                optionLabel="label"
                                placeholder=" Sélectionner une matiere"
                                filter
                                className="w-full md:w-25rem my-custom-class" // Ajoutez votre classe ici
                                style={{ width: '100%', height: '40px' }} // Ajustez la largeur et la hauteur ici
                              />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="mr-0" />
                  <div className="col-md-12 text-center">
                    <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">
                      Affecter les classes à l'enseignant
                    </h5>
                  </div>
                  <Container>
                    <Table id="mytable">
                      <thead>
                        <tr>
                          <th className="fw-bold">Classe</th>
                          <th className="fw-bold">Options de Classe</th>
                          <th className="fw-bold">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...Array(groupCount)].map((_, index) => (
                          <tr key={index}>
                            <td>
                              <Form.Select
                                name={`classes[${index}]`}
                                className="form-select form-select-md"
                                onChange={(event) =>
                                  handleClasseSelection(event, index)
                                }
                              >
                                <option value="" disabled selected>
                                  -- Selectionnez une classe --
                                </option>
                                {classes.length > 0 &&
                                  classes.map((item) => {
                                    // Vérifiez si la classe est déjà sélectionnée
                                    if (!selectedClasses.includes(item.id)) {
                                      return (
                                        <option key={item.id} value={item.id}>
                                          {item.libelleClasse}
                                        </option>
                                      );
                                    }
                                    return null;
                                  })}
                              </Form.Select>
                            </td>
                            <td>
                              <Select
                                options={availableOptions[index] || []}
                                isMulti
                                onChange={(selectedOptions) =>
                                  handleClasseOptionsSelection(
                                    selectedOptions,
                                    index
                                  )
                                }
                                value={selectedClasseOptions[index]}
                                components={animatedComponents}
                              />
                            </td>
                            <td>
                              {index === 0 ? (
                                <Button id="btnadd" onClick={addRow}>
                                  Ajouter
                                </Button>
                              ) : (
                                <Button
                                  id="btnsupprimer"
                                  variant="danger"
                                  onClick={() => removeRow(index)}
                                >
                                  Supprimer
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Container>
                  <div className="col-md-8 mt-4 ">
                    <div className="row">
                      <div className="col-md-3 ">
                        <button type="submit" className="btn btn-primary">
                          Enregistrer
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          {/* /Bootstrap Validation */}

          <>
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title className="text-white">
                  Enregistrement matière
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form
                  className="needs-validation"
                  noValidate
                  onSubmit={storeMatiere}
                >
                  <div className="row">
                    <div className=" col-md-6 mb-3">
                      <Form.Label className="form-label fw-bold" htmlFor="name">
                        Libelle <i className="text-danger">*</i>
                      </Form.Label>
                      <Form.Control
                        className="form-control"
                        id="libelleMatiere"
                        type="text"
                        value={libelleMatiere}
                        onChange={(e) => setLibelleMatiere(e.target.value)}
                        placeholder=""
                        required={true}
                        maxLength={100}
                        minLength={3}
                      />
                    </div>

                    <div className=" col-md-6 mb-3">
                      <Form.Label className="form-label fw-bold" htmlFor="name">
                        Coefficient <i className="text-danger">*</i>
                      </Form.Label>
                      <Form.Control
                        className="form-control"
                        id="coefficientMatiere"
                        type="number"
                        value={coefficientMatiere}
                        onChange={(e) => setCoefficientMatiere(e.target.value)}
                        placeholder=""
                        required={true}
                        maxLength={30}
                        minLength={1}
                      />
                    </div>
                  </div>

                  <div className=" mb-3">
                    <Form.Label
                      className="form-label fw-bold"
                      htmlFor="descriptionMatiere"
                    >
                      Description <i className="text-danger"></i>
                    </Form.Label>
                    <textarea
                      className="form-control"
                      id="descriptionMatiere"
                      onChange={(e) => setDescriptionMatiere(e.target.value)}
                      name="descriptionMatiere"
                      rows="3"
                    ></textarea>
                  </div>

                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Fermer
                    </Button>
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={handleClose}
                    >
                      Enregistrer
                    </Button>
                  </Modal.Footer>
                </Form>
              </Modal.Body>
            </Modal>
          </>
        </div>
      </div>
    </Layout>
  );
}
